import { useNetworkMutation } from '@/lib/utils/request'

export interface CreateAlertPayload extends Record<string, unknown> {
  enabled: boolean
  title: string
  organization: number
  emails: string[]
  phoneNumbers: string[]
  templateName: string
  templateVariables: Record<string, number>
  /** Vehicle tag ids. Empty means the alert is global. */
  tags: number[]
}

export interface CreatedAlert {
  enabled: boolean
  title: string
  organization: number
  emails: string[]
  phoneNumbers: string[]
  templateName: string
  templateVariables: Record<string, number>
  /** Vehicle tag ids. Empty means the alert is global. */
  tags: number[]
}

export const useCreateAlert = () =>
  useNetworkMutation<CreatedAlert, CreateAlertPayload>({
    url: 'v1/alerts/',
    method: 'post',
  })
